import { mask } from "remask";

export function maskCpf(value: string) {
  return mask(value, '999.999.999-99')
}

export function removeMask(value: string) {
  return value.replace(/\D/g, '');
}
